





























import {
  PrintAreaCustomization,
  WarehouseItemCustomization,
  PrintArea,
} from "@/models";
import { customizationStore } from "@/store/typed";
import StoreSubscriber from "@/helpers/StoreSubscriber";
import { Vue, Component, Prop } from "vue-property-decorator";
import Throttler from "@/helpers/Throttler";
import { previewBus } from "@/main";

@Component({})
export default class Item extends Vue {
  @Prop({ required: true })
  readonly warehouseItemCustomization: WarehouseItemCustomization;

  @Prop({ required: true })
  readonly customizationPrintArea!: PrintAreaCustomization;

  private open = false;

  private throttler = new Throttler();

  preview = this.customizationPrintArea?.imageOutput || null;

  mounted() {
    previewBus.$on("preview" + this.customizationPrintArea.id, async (data) => {
      if (this.updateable) {
        this.preview = data;
      }
    });
  }

  get updateable(): boolean{
    return customizationStore.updateable;
  }
  
  get printArea(): PrintArea {
    return this.customizationPrintArea.printArea;
  }

  async onSelect(): Promise<void> {
    customizationStore.setMode("2d");
    if (customizationStore.navigationLocked) {
      return;
    }
    customizationStore.setWarehouseItemCustomization(
      this.warehouseItemCustomization
    );
    customizationStore.setPrintAreaCustomization(
      Object.assign(new PrintAreaCustomization(), this.customizationPrintArea)
    );
  }

  get isCurrentPrintAreaCustomization(): boolean {
    return !!(
      customizationStore.currentPrintAreaCustomization?.id ===
      this.customizationPrintArea.id
    );
  }

  get done(): boolean {
    return !!this.customizationPrintArea.completed;
  }
}
